import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Auth from '../../../../data/auth-service';
import Permissions from '../../../../data/permissions';
import DisplayCard from '../../../../components/displaycard';

const snmp = [
    {
        title: 'CMC',
        description: 'Configure CMC SNMP settings',
        img: '/images/cmc.png',
        route: '/system/configuration/snmp/cmc',
        perm: {
            SNMP: [...Permissions.System.Configuration.SNMP],
        },
    },
    {
        title: 'Datanode',
        description: 'Configure Datanode SNMP settings',
        img: '/images/datanode.png',
        route: '/system/configuration/snmp/datanode',
        perm: {
            Cluster: [...Permissions.Cluster],
        },
    },
];

const Snmp = () => {
    return (
        <Box mb={2}>
            <Grid container spacing={5}>
                {snmp
                    .filter(o => Auth.perm(o.perm))
                    .map((p, i) => (
                        <Grid item xl={3} lg={4} key={`snmp-card-${i}`}>
                            <DisplayCard {...p} noButton/>
                        </Grid>
                    ))}
            </Grid>
        </Box>
    );
}

export default Snmp;